import cx from "classnames";
import PropTypes from "prop-types";

import styles from "./Loading.module.scss";

const Loading = ({ size, spinnerClassName, className }) => {
  let loadingClassName = "d-flex justify-content-center align-items-center";
  loadingClassName += className ? ` ${className}` : "";

  return (
    <div className={loadingClassName}>
      <div
        className={cx(styles.spinner, spinnerClassName)}
        style={{ width: `${size}rem`, height: `${size}rem` }}
        data-testid="spinner"
      >
        <div style={{ width: `${size}rem`, height: `${size}rem` }} />
        <div style={{ width: `${size}rem`, height: `${size}rem` }} />
      </div>
    </div>
  );
};

Loading.defaultProps = {
  spinnerClassName: "",
  size: 3.2,
  className: "",
};

Loading.propTypes = {
  spinnerClassName: PropTypes.string,
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default Loading;
